import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

//* Styles
import CustomCollapseStyle from './style';

const CustomCollapse = ({ isCollapsed, children }) => {
	const nodeRef = useRef(null);

	return (
		<CustomCollapseStyle className='collapse-container'>
			<CSSTransition
				timeout={500}
				unmountOnExit
				in={isCollapsed}
				nodeRef={nodeRef}
				classNames='collapse'>
				<div
					ref={nodeRef}
					className='collapsed-content'>
					{children}
				</div>
			</CSSTransition>
		</CustomCollapseStyle>
	);
};

export default CustomCollapse;
